import { Button } from "./Button";
import { forwardRef } from "react";
import { mergeProps, resolveChildren, useCheckableProps } from "../../shared";
import { useToggleButton } from "./useToggleButton";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "button";
export function InnerToggleButton(props) {
  const [checkableProps, isCheckable] = useCheckableProps(props);
  const {
    active,
    checked,
    children,
    defaultChecked,
    forwardedRef,
    onChange,
    onCheck,
    shape,
    value,
    variant,
    ...rest
  } = mergeProps(props, checkableProps);
  const {
    buttonProps
  } = useToggleButton({
    active,
    checked,
    defaultChecked,
    forwardedRef,
    isCheckable,
    onChange,
    onCheck,
    shape,
    value,
    variant
  });
  const content = resolveChildren(children);
  return /*#__PURE__*/_jsx(Button, { ...mergeProps(rest, buttonProps),
    children: content
  });
}
InnerToggleButton.defaultElement = DefaultElement;
export const ToggleButton = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerToggleButton, { ...props,
  forwardedRef: ref
}));